



































import Vue from "vue";

export default Vue.extend({
  name: "FilterBox",
  props: {
    group: {
      type: Object as () => {},
      required: true
    },
    translations: {
      type: Object as () => {},
      required: true
    },
    config: {
      type: Object as () => {},
      required: true
    },
    totalTags: {
      type: Number,
      required: true
    }
  }
});
